/**
 * Get Store Delivery Transaction Use Case — Business Logic Layer (Clean Architecture).
 * جلب تفاصيل معاملة تسليم
 */

import {StoreDeliveriesRepository} from '../repository/StoreDeliveriesRepository';
import {StoreDeliveryTransaction} from '../models/storeDeliveries.model';

export class GetStoreDeliveryTransactionUseCase {
  constructor(private readonly repository: StoreDeliveriesRepository) {}

  async execute(transactionId: string): Promise<StoreDeliveryTransaction> {
    if (!transactionId) {
      throw new Error('Transaction ID is required');
    }
    return this.repository.getTransaction(transactionId);
  }
}
